import Amenity from "../../../models/amenity";
import {Select} from "@blueprintjs/select";
import {Button, Classes, MenuItem} from "@blueprintjs/core";
import React, {useState} from "react";

interface Props {
  amenity?: Amenity;
  onChange: (amenity: Amenity) => void;
}

const AppleOccupantSelect = Select.ofType<string>()

export function IMDFOccupantSelect({ amenity, onChange }: Props) {
  const [query, setQuery] = useState('');

  const onSelect = (imdfAmenity: string) => {
    const _amenity = new Amenity(amenity);
    _amenity.imdf = imdfAmenity;
    onChange(_amenity)
  }

  return (
    <AppleOccupantSelect
      onItemSelect={onSelect}
      items={IMDFAmenities.filter(i => i.toLowerCase().includes(query.toLowerCase()))}
      popoverProps={{ minimal: true, usePortal: false }}
      filterable={true}
      onQueryChange={setQuery}
      query={query}
      itemRenderer={(item, options) =>
        <MenuItem
          key={`category-select-${item}`}
          text={item}
          onClick={options.handleClick}
        />
      }>
      <Button
        className={Classes.MINIMAL}
        text={amenity?.imdf ? amenity.imdf : 'Select IMDF Amenity Category'}
        style={{ marginRight: 20 }}
        rightIcon={"chevron-down"}
      />
    </AppleOccupantSelect>
  );
}

const IMDFAmenities = [
  '3dprinting',
  'acai',
  'accessories',
  'accounting',
  'acnetreatment',
  'acupuncture',
  'adoptionservices',
  'adulteducation',
  'adultentertainment',
  'adultstore',
  'advertising',
  'advisoryservices',
  'afghani',
  'african',
  'agritourism',
  'airfield',
  'airline',
  'airport.regional',
  'airportloungebar',
  'airportshuttle',
  'airsoft',
  'allergies',
  'alternativemedicine',
  'american.modern',
  'amusementpark',
  'amusementpark.ride',
  'animalshelter',
  'antiques',
  'apmstop',
  'appliances',
  'arabian',
  'arabian.pizza',
  'arcade',
  'archery',
  'architecture',
  'argentine',
  'armenian',
  'artgallery',
  'artinstruction',
  'arts.entertainment',
  'artsandcrafts',
  'artschool',
  'artstudio',
  'artstudio.rental',
  'artsupplies',
  'asianfusion',
  'astrologist',
  'asturian',
  'atm',
  'atm.cryptocurrency',
  'audiovideoequipment',
  'auditory',
  'australian',
  'australian.modern',
  'austrian',
  'austrian.schnitzel',
  'auto.accessibilityequipment',
  'auto.bodyshop',
  'auto.carbuyer',
  'auto.carshare',
  'auto.carwash',
  'auto.dealer.boat',
  'auto.dealer.car',
  'auto.dealer.motorcycle',
  'auto.dealer.rv',
  'auto.dentrepair.mobile',
  'auto.detailing',
  'auto.electric',
  'auto.evcharge',
  'auto.evcharge.dcfast',
  'auto.evcharge.tesla',
  'auto.glass',
  'auto.oilchange',
  'auto.parts',
  'auto.repair',
  'auto.repair.transmission',
  'auto.repair.wheelrim',
  'auto.repair.windshield',
  'auto.servicestation',
  'auto.shipping',
  'auto.stereoinstallation',
  'auto.tires',
  'auto.upholstery',
  'automotive',
  'autopartssupplies',
  'babyclothesandsupplies',
  'bagels',
  'bakedgoods',
  'ballonservices',
  'bangladeshi',
  'bank',
  'bar',
  'barbecue',
  'barber',
  'barfood',
  'barreclass',
  'baseballfield',
  'bathingarea',
  'batteries',
  'battingcages',
  'beach',
  'beautysalon',
  'beautyspas',
  'bedbreakfast',
  'beerbar',
  'beergarden',
  'beerhall',
  'beerwineandspirits',
  'beerwinespirits',
  'beisl',
  'belgian',
  'belgian.flemish',
  'bengali',
  'beveragestore',
  'bicycle.repair',
  'bicyclerental',
  'bicycleshop',
  'bikesandequipment',
  'billingservices',
  'bingo',
  'biryani',
  'bistro',
  'blacksea',
  'blinds',
  'blooddonation',
  'blooddonationcenter',
  'bodycontouring',
  'bodypiercing',
  'books',
  'booksmagazinesmusicvideo',
  'botanicalgarden',
  'bowlingalley',
  'boxing',
  'brazilian',
  'brazilian.centralbrazil',
  'brazilian.empanadas',
  'brazilian.northeasternbrazil',
  'brazilian.northernbrazil',
  'breakfastandbrunch',
  'brewery',
  'brewpub',
  'bridalstore',
  'british',
  'bubbletea',
  'buffet',
  'buildingsupplies',
  'bulgarian',
  'bulkmedicalbilling',
  'bungeejumping',
  'burgers',
  'burmese',
  'businesscampus',
  'businessconsulting',
  'busrental',
  'busstop',
  'butcher',
  'cabinets',
  'cafe',
  'cafeteria',
  'cajun',
  'cakes',
  'calligraphy',
  'cambodian',
  'canadian.modern',
  'candy',
  'candy.dagashi',
  'cannabisdispensary',
  'canteen',
  'cardioclasses',
  'cardiology',
  'cards.stationery',
  'careercounseling',
  'caribbean',
  'caricaturist',
  'carouselride',
  'carpet',
  'carrental',
  'catering',
  'cellphoneaccessories',
  'challengecourse',
  'champagnebar',
  'cheese',
  'cheesesteaks',
  'chickenshop',
  'chickenwings',
  'childbirthschool',
  'childcare',
  'chilean',
  'chimneycakes',
  'chinese',
  'chinese.cantonese',
  'chinese.dimsum',
  'chinese.fuzhou',
  'chinese.hainan',
  'chinese.hakka',
  'chinese.henghwa',
  'chinese.hokkien',
  'chinese.hunan',
  'chinese.pekinese',
  'chinese.shanghainese',
  'chinese.szechuan',
  'chinese.teochew',
  'chinesebazaar',
  'chiropractic',
  'chocolate',
  'christmastrees',
  'churros',
  'cider',
  'cigarbar',
  'cinema',
  'cityhall',
  'climbing',
  'clinic',
  'clockrepair',
  'clothing',
  'clothing.bespoke',
  'clothing.childrens',
  'clothing.mens',
  'clothing.plussize',
  'clothing.womens',
  'cocktailbar',
  'coffee',
  'coffee.tea',
  'coffeeroaster',
  'coffeeteasupplies',
  'coincashingkiosk',
  'college',
  'colombian',
  'comedyclub',
  'comfortfood',
  'comicbooks',
  'commercialrealestate',
  'commissionedartists',
  'communitybookbox',
  'communitycenter',
  'computersandaccessories',
  'conceptshop',
  'concourse',
  'condominium',
  'congee',
  'constructionequipmentrental',
  'contractors',
  'conveniencestore',
  'conveyorsushi',
  'cooking.instruction',
  'cookingschool',
  'copyshop',
  'corporateheadquarters',
  'corporateoffices',
  'corsican',
  'cosmetics',
  'cosmeticsurgery',
  'cosmetologyschool',
  'costumes',
  'countertopinstallation',
  'countryclub',
  'courier',
  'crepes',
  'cryotherapy',
  'cuban',
  'culturalcenter',
  'cupcakes',
  'currencyexchange',
  'customcakes',
  'custommerchandise',
  'cyclingclass',
  'cypriot',
  'czech',
  'danceclub',
  'danceschool',
  'dancestudio',
  'dancewear',
  'danish',
  'datarecovery',
  'dayspa',
  'dealer.usedvehicle',
  'delicatessen',
  'delicatessen.sandwiches',
  'dentalhygiene',
  'dentistry',
  'dentistry.cosmetic',
  'dentistry.general',
  'dentistry.pediatric',
  'departmentstore',
  'deptartmentstore',
  'dermatology',
  'desserts',
  'diagnosticimaging',
  'diagnosticservices',
  'dialysis',
  'dietician',
  'digitizingservices',
  'diner',
  'dinnertheater',
  'discountstore',
  'distillery',
  'divebar',
  'diyfood',
  'dmv',
  'dominican',
  'donair',
  'donationcenter',
  'donuts',
  'doorsalesandinstallation',
  'drivingrange',
  'drivingschool',
  'drycleaning',
  'drycleaninglaundry',
  'dumplings',
  'dumpsterrental',
  'dutyfree',
  'earnosethroat',
  'easterneuropean',
  'eatertainment',
  'editorialservices',
  'education',
  'educationservices',
  'egyptian',
  'electricians',
  'electronicappliances',
  'electronicparts',
  'electronicsrepair',
  'elementaryschool',
  'embroiderycrochet',
  'emergencymedicine',
  'emissionstesting',
  'empanadas',
  'employmentagency',
  'endodontics',
  'engraving',
  'escapegame',
  'ethiopian',
  'ethnicgrocerystore',
  'european.modern',
  'eventplanning',
  'eventspace',
  'experiences',
  'eyelashes',
  'eyewear.opticians',
  'fabricstore',
  'fairground',
  'falafel',
  'familyfriendly',
  'familyfuncenter',
  'familymedicine',
  'familyplanning',
  'familyrestaurant',
  'farm',
  'farmersmarket',
  'fashion',
  'fashionaccessories',
  'fastfood',
  'fencing',
  'fengshui',
  'ferry',
  'fieldofplay',
  'filipino',
  'financialservices',
  'fingerprinting',
  'firearmstrainingschool',
  'fish',
  'fishandchips',
  'fitnessbootcamp',
  'fitnessequipment',
  'fitnessinstruction',
  'fixedbaseoperator',
  'flatbread',
  'flightinstructionschool',
  'floatspa',
  'flooringinstallationandrepair',
  'floraldesign',
  'florist',
  'florists',
  'flowers',
  'fondue',
  'foodcourt',
  'fooddelivery',
  'foodstand',
  'foodtruck',
  'formalwear',
  'formalwear.rental',
  'freiduria',
  'french',
  'french.alsatian',
  'french.auvergnat',
  'french.baguette',
  'french.berrichon',
  'french.bourguignon',
  'french.brasserie',
  'french.lyonnais',
  'french.nicois',
  'french.provencal',
  'friterie',
  'frozenfoods',
  'fruitandvegetables',
  'fuelstation',
  'funeralservices',
  'furclothing',
  'furniture',
  'furniture.rental',
  'furniturestore',
  'gardening',
  'gastroenterology',
  'gastropubs',
  'gelato',
  'georgian',
  'german',
  'german.baden',
  'german.bavarian',
  'german.currysausage',
  'german.easterngerman',
  'german.fischbroetchen',
  'german.franconian',
  'german.hessian',
  'german.heuriger',
  'german.northerngerman',
  'german.palatine',
  'german.rhinelandian',
  'german.swabian',
  'giblets',
  'giftshops',
  'glutenfree',
  'gokarting',
  'goldmerchants',
  'golf',
  'golf.instruction',
  'golfequipment',
  'golfshop',
  'gourmetfood',
  'gourmetmarket',
  'graphicaldesign',
  'greek',
  'grillingequipment',
  'grocery',
  'grocery.asian',
  'grocery.chinese',
  'grocery.indian',
  'grocery.japanese',
  'grocery.korean',
  'grocery.persian',
  'grocerystore',
  'guitarstore',
  'gunrange',
  'gunsandammo',
  'gym',
  'gymnastics',
  'hairblowout',
  'haircutsstyling',
  'haircutsstyling.mens',
  'hairextensions',
  'hairloss',
  'hairremoval',
  'hairremoval.laser',
  'hairremoval.threading',
  'hairremoval.waxing',
  'hairstylist',
  'haitian',
  'halal',
  'hardware',
  'hats',
  'hauntedhouse',
  'hawaiian',
  'headshop',
  'healthcare',
  'healthcarecenter',
  'healthyfoods',
  'hearingaidproviders',
  'hearingaids',
  'hennaartist',
  'herbalmedicine',
  'herbsandspices',
  'highschool',
  'himalayan',
  'hobbyshop',
  'holidaydecorations',
  'homeandgarden',
  'homeappliancerepair',
  'homeautomation',
  'homecleaning',
  'homedecor',
  'homedevelopers',
  'homegarden',
  'homehealthcare',
  'homeopathy',
  'hometheaterinstallation',
  'honey',
  'hongkong.cafe',
  'hookahbar',
  'horsequipment',
  'hospital',
  'hostel',
  'hotdogs',
  'hotel',
  'hotel.business',
  'hotel.capsule',
  'hotelbar',
  'hotpot',
  'hottubandpool',
  'housingcooperative',
  'hungarian',
  'huntingfishingsupplies',
  'hvac',
  'hypermarket',
  'iberian',
  'icecream',
  'importedfood',
  'indian',
  'indian.andhra',
  'indian.assamese',
  'indian.awadhi',
  'indian.bihari',
  'indian.chettinad',
  'indian.goan',
  'indian.gujarat',
  'indian.hyderabadi',
  'indian.kerala',
  'indian.konkan',
  'indian.lucknowi',
  'indian.maharashtrian',
  'indian.malwani',
  'indian.mangalorean',
  'indian.northindian',
  'indian.oriya',
  'indian.rajasthani',
  'indian.southindian',
  'indonesian',
  'informationtechnology',
  'installmentloanservices',
  'insulationinstallation',
  'insurance',
  'insurance.auto',
  'insurance.health',
  'insurance.home',
  'insurance.life',
  'interiordesign',
  'internalmedicine',
  'internationalfood',
  'internetbooth',
  'internetcafe',
  'internetserviceprovider',
  'investmentbanking',
  'irish',
  'irishpub',
  'israeli',
  'italian',
  'italian.abruzzese',
  'italian.altoatesine',
  'italian.apulian',
  'italian.calabrian',
  'italian.cucinacampana',
  'italian.diner',
  'italian.emilian',
  'italian.friulan',
  'italian.lumbard',
  'italian.napoletana',
  'italian.norcinerie',
  'italian.piedmont',
  'italian.roman',
  'italian.sardinian',
  'italian.sicilian',
  'italian.tuscan',
  'italian.venetian',
  'ivhydration',
  'izakaya',
  'japanese',
  'japanese.bento',
  'japanese.blowfish',
  'japanese.curry',
  'japanese.donburi',
  'japanese.gyudon',
  'japanese.handrolls',
  'japanese.horumon',
  'japanese.kushikatsu',
  'japanese.nikkei',
  'japanese.oden',
  'japanese.okonomiyaki',
  'japanese.onigiri',
  'japanese.oyakodon',
  'japanese.ramen',
  'japanese.shabushabu',
  'japanese.soba',
  'japanese.sukiyaki',
  'japanese.takoyaki',
  'japanese.tempura',
  'japanese.teppanyaki',
  'japanese.tonkatsu',
  'japanese.udon',
  'japanese.unagi',
  'japanese.westernjapanese',
  'japanese.yakiniku',
  'japanese.yakitori',
  'japanesesweets',
  'jewelry',
  'jewelryrepair',
  'jewish',
  'juicebar',
  'kaiseki',
  'karaoke',
  'kashmiri',
  'kebab',
  'kidsactivities',
  'kimonos',
  'kindergarten',
  'kiosk',
  'kiosk.food',
  'kitchenandbath',
  'kitchenincubator',
  'knifesharpening',
  'knittingsupplies',
  'kopitiam',
  'korean',
  'kosher',
  'kurdish',
  'laboratorytesting',
  'landmark',
  'landscaping',
  'languageschool',
  'laotian',
  'lasereyesurgery',
  'lasertag',
  'latinamerican',
  'laundromat',
  'laundryservices',
  'lawyer',
  'lawyer.business',
  'lawyer.criminaldefense',
  'lawyer.divorce',
  'lawyer.estateplanning',
  'lawyer.immigration',
  'lawyer.litigation',
  'lawyer.personalinjury',
  'lawyer.realestate',
  'lawyer.tax',
  'lawyer.willtrustprobate',
  'lawyer.workerscomp',
  'leathergoods',
  'lebanese',
  'legalservices',
  'library',
  'lifecoach',
  'lighting',
  'ligurian',
  'limo',
  'linens',
  'lingerie',
  'livestocksales',
  'localservices',
  'locksmith',
  'lotterystand',
  'loungebar',
  'luggage',
  'luggagestorage',
  'macaron',
  'magicians',
  'mailboxcenter',
  'makeupartist',
  'malaysian',
  'mamak',
  'manicurists',
  'marketing',
  'martialarts',
  'massageschool',
  'massagetherapist',
  'massagetherapy',
  'maternitywear',
  'mattresses',
  'mauritian',
  'meatballs',
  'medicalcenter',
  'medicalspa',
  'medicalsupplies',
  'mediterranean',
  'mexican',
  'mexican.easternmexican',
  'mexican.jaliscan',
  'mexican.modern',
  'mexican.northernmexican',
  'mexican.oaxacan',
  'mexican.pueblan',
  'mexican.yucatan',
  'middleeastern',
  'militarybase',
  'milkbar',
  'milkshakes',
  'minigolf',
  'mobilephonerepair',
  'mobilephones',
  'moneytransferservices',
  'mongolian',
  'moroccan',
  'mortgagebroker',
  'motorcyclingclothing',
  'movierental.kiosk',
  'mughlai',
  'museum.art',
  'museum.children',
  'museum.history',
  'musicalinstruments',
  'musicalinstrumentservices',
  'musicvenue',
  'musicvideo',
  'naga',
  'nasilemak',
  'naturopathy',
  'nepalese',
  'newspapersandmagazines',
  'newzealand',
  'nicaraguan',
  'nightfood',
  'nonprofit',
  'noodles',
  'northamerican.traditional',
  'norwegian',
  'notarypublic',
  'nurseries.gardening',
  'nyonya',
  'obgyn',
  'observatory',
  'occupationaltherapy',
  'officebuilding',
  'officeequipmentandsupplies',
  'okinawan',
  'oliveoil',
  'opensandwiches',
  'opera.ballet',
  'opthamalogy',
  'opticians',
  'optometry',
  'oralsurgery',
  'organicfood',
  'oriental',
  'orthodontics',
  'orthopedics',
  'orthotics',
  'osteopathy',
  'ottoman',
  'outdoorfurniture',
  'outdoorgear',
  'outletmall',
  'outletstore',
  'oxygenbar',
  'pachinko',
  'packagelocker',
  'packing',
  'packingsupplies',
  'paella',
  'painmanagement',
  'paintandsip',
  'painting',
  'paintstores',
  'paintyourownpottery',
  'pakistani',
  'parentingschool',
  'parking',
  'parks',
  'parma',
  'parsi',
  'partycharacters',
  'partyequipment.rental',
  'partysupplies',
  'passportvisaservices',
  'pasta',
  'pathology',
  'pawn',
  'paydayloan',
  'pediatrics',
  'performingarts',
  'perfume',
  'periodontics',
  'permanentmakeup',
  'persian',
  'personalcare',
  'personalshopper',
  'personaltrainer',
  'peruvian',
  'pets',
  'pets.adoption',
  'pets.boarding',
  'pets.grooming',
  'pets.photography',
  'pets.sitting',
  'pets.training',
  'pets.transportation',
  'petstore',
  'petstore.fish',
  'petstore.reptile',
  'pharmacy',
  'pharmacystore',
  'phonechargingstation',
  'photobooth.rental',
  'photography',
  'photography.event',
  'photography.session',
  'photographyequipment',
  'photographystore',
  'physicaltherapy',
  'physician',
  'piadina',
  'pianobar',
  'pianostore',
  'pictureframing',
  'pilates',
  'pita',
  'pizza',
  'placeofworship',
  'placeofworship.church',
  'placeofworship.mosque',
  'placeofworship.synagogue',
  'placeofworship.unitarian',
  'planetarium',
  'plasticsurgery',
  'playcenter',
  'playground',
  'playsets',
  'plaza',
  'podiatrists',
  'podiatry',
  'poke',
  'poledancingschool',
  'policestation',
  'policestation.koban',
  'polish',
  'polish.pierogis',
  'poolcleaning',
  'poolhall',
  'pooltablesupplies',
  'popcorn',
  'popup',
  'popupshops',
  'portuguese',
  'portuguese.alentejo',
  'portuguese.algarve',
  'portuguese.azores',
  'portuguese.beira',
  'portuguese.fadohouse',
  'portuguese.madeira',
  'portuguese.minho',
  'portuguese.ribatejo',
  'portuguese.trasosmontes',
  'postoffice',
  'postoffice.authorizedagent',
  'potatoes',
  'poutineries',
  'prenatal',
  'preschool',
  'pretzels',
  'preventivemedicine',
  'printmedia',
  'privateinvestigation',
  'privatejetcharter',
  'privateschool',
  'privateshuttlebus',
  'professionalservices',
  'professionalsportsteam',
  'propertymanagement',
  'psychiatrists',
  'psychiatry',
  'psychic',
  'psychology',
  'pub',
  'publicart',
  'publiclibrary',
  'publicservices.government',
  'publictransport',
  'puertorican',
  'pulmonology',
  'punjabi',
  'racetrack',
  'radiology',
  'radiostation',
  'rawfood',
  'realestate.agents',
  'realestate.services',
  'realestateagents',
  'realestateagents.commercial',
  'realestateservices',
  'recordingstudio',
  'recreation',
  'recreationcenter',
  'recyclingcenter',
  'reflexology',
  'religiousitems',
  'rental.videoandgame',
  'researchanddevelopment',
  'residentialapartments',
  'restaurant',
  'retirementhome',
  'reunionnese',
  'reupholstery',
  'riceshop',
  'rideshare',
  'robatayaki',
  'rockclimbing',
  'rodizio',
  'romanian',
  'roofing',
  'rotisseriechicken',
  'rugs',
  'russian',
  'sakebar',
  'salad',
  'salvadoran',
  'sandwiches',
  'sauna',
  'scandinavian',
  'scandinaviandesign',
  'school',
  'scottish',
  'screenprinting',
  'screenprinting.tshirt',
  'seafood',
  'seafoodmarket',
  'securitysystems',
  'selfstorage',
  'senegalese',
  'seniorcenter',
  'serbianandcroatian',
  'sewingalterations',
  'sharedofficespace',
  'shavedice',
  'shavedsnow',
  'shippingcenters',
  'shippingdropbox',
  'shoerepair',
  'shoes',
  'shoeshine',
  'shoestore',
  'shopping',
  'shoppingpassage',
  'shutterinstallation',
  'signature',
  'signmaking',
  'silentdisco',
  'singaporean',
  'skatepark',
  'skatingequipment',
  'skatingrink',
  'skiequipment',
  'skincare',
  'skydiving',
  'sleepwear',
  'slovakian',
  'soccer',
  'socialclub',
  'socialservices',
  'softwaredevelopment',
  'solarinstallation',
  'sommeliers',
  'soulfood',
  'soup',
  'southafrican',
  'southernunitedstates',
  'southwestunitedstates',
  'souvenirs',
  'spanish',
  'spanish.andalusian',
  'spanish.basque',
  'spanish.catalan',
  'spanish.galician',
  'specialtyfood',
  'specialtyschool',
  'spinclass',
  'spiritualproducts',
  'sportinggoods',
  'sportsbar',
  'sportsclub',
  'sportsequipment.rental',
  'sportsgoods',
  'sportsmedicine',
  'sportsschool',
  'sportswear',
  'srilankan',
  'stationery',
  'steak',
  'stockings',
  'streetvendor',
  'structuralengineers',
  'subwaystation',
  'supermarket',
  'supperclub',
  'surfacerefinishing',
  'surfing',
  'surfingequipment',
  'surgeon',
  'sushi',
  'swedish',
  'swedish.traditional',
  'swimminginstruction',
  'swimmingpool',
  'swimwear',
  'swiss',
  'syrian',
  'taberna',
  'tabletopgames',
  'tableware',
  'tacos',
  'taiwanese',
  'taiyaki',
  'talentagencies',
  'tamales',
  'tanningbeds',
  'tanningservices',
  'tapas',
  'tapas.smallplate',
  'tattoo',
  'tattoo.removal',
  'taxi',
  'taxistand',
  'taxoffice',
  'taxservices',
  'tea',
  'teachersupplies',
  'teambuilding',
  'teethwhitening',
  'telecommunications',
  'televisionserviceproviders',
  'televisionstation',
  'tennis.instruction',
  'terminal',
  'terminal.bus',
  'testpreparationschool',
  'texmex',
  'thai',
  'theater.drivein',
  'theater.movie',
  'themedcafe',
  'thriftstore',
  'tibetan',
  'tickets',
  'tikibar',
  'titleloan',
  'tobaccoshop',
  'tofu',
  'touristattraction',
  'tours',
  'tours.boat',
  'tours.bus',
  'tours.scooter',
  'tours.walking',
  'towncarservice',
  'toys',
  'toystore',
  'traditionalchinesemedicine',
  'trainserviceprovider',
  'trainstation',
  'trampolining',
  'transitlounge',
  'translationservices',
  'transportationservices',
  'trattoria',
  'travelagent',
  'travelservices',
  'trinidadian',
  'trophyshops',
  'truckrental',
  'tuina',
  'turkish',
  'turkish.cheekufta',
  'turkish.gozleme',
  'turkish.homemadefood',
  'turkish.lahmacun',
  'turkish.ravioli',
  'tutoring',
  'ukrainian',
  'uniforms',
  'urgentcare',
  'usedbooks',
  'utilities',
  'uzbek',
  'vacationhome',
  'vacationhome.agent',
  'valetservices',
  'vapeshops',
  'vascularmedicine',
  'vegan',
  'vegetarian',
  'vendingmachine',
  'vendingmachine.beverage',
  'venezuelan',
  'venison',
  'veteransorganization',
  'veterinarian',
  'videofilmproduction',
  'videogamesandconsoles',
  'vietnamese',
  'vintageclothing',
  'vinylrecords',
  'virtualreality',
  'visitorcenter',
  'vitaminssupplements',
  'vocalcoach',
  'vocationalschool',
  'waffles',
  'walkinclinic',
  'warehouse',
  'watches',
  'watchrepair',
  'waterpark',
  'waterpurification',
  'webdesign',
  'weddingchappel',
  'weddingplanning',
  'weightloss',
  'welsh',
  'whiskeybar',
  'wholesalemerchant',
  'wholesaler',
  'wigs',
  'windowinstallation',
  'winebar',
  'winery',
  'winetasting',
  'wok',
  'wraps',
  'yoga',
  'youthclub',
  'yugoslav',
]
